var mapStyles = [
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e9e9e9'
      },
      {
        lightness: 17
      }
    ]
  }, {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5'
      },
      {
        lightness: 20
      }
    ]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        lightness: 17
      }
    ]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        lightness: 29
      },
      {
        weight: 0.2
      }
    ]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        lightness: 18
      }
    ]
  }, {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        lightness: 16
      }
    ]
  }, {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5'
      },
      {
        lightness: 21
      }
    ]
  }, {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dedede'
      },
      {
        lightness: 21
      }
    ]
  }, {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        visibility: 'on'
      },
      {
        color: '#ffffff'
      },
      {
        lightness: 16
      }
    ]
  }, {
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: 36
      },
      {
        color: '#333333'
      },
      {
        lightness: 40
      }
    ]
  }, {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  }, {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f2f2f2'
      },
      {
        lightness: 19
      }
    ]
  }, {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fefefe'
      },
      {
        lightness: 20
      }
    ]
  }, {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#fefefe'
      },
      {
        lightness: 17
      },
      {
        weight: 1.2
      }
    ]
  }
];

var parkingAreas = window.parkingAreas;
var helsinkiLocation = { lat: 60.16985569999999, lng: 24.9383791 };
var mapMarkers = [];
var markers = {};
var infoWindows = {};

window.initParkingMap = initParkingMap;

function initParkingMap() {

  for(var i = 0; i < parkingAreas.length; i++) {
    parkingAreas[i].areas.map(function(area) {
      mapMarkers.push(area);
    });
  }

  var map = new window.google.maps.Map(document.getElementById('map'), { zoom: 12, center: helsinkiLocation });

  setMarkers(map);

  map.set('styles', mapStyles);

}

function setMarkers(map) {

  for(var i = 0; i < mapMarkers.length; i++) {

    var position = { lat: parseFloat(mapMarkers[i].lat), lng: parseFloat(mapMarkers[i].lng) };
    var markerId = mapMarkers[i].id;
    var mapQuery = 'https://www.google.com/maps/dir//' + mapMarkers[i].lat + ',' + mapMarkers[i].lng + '/';

    var content = mapMarkers[i].image ? '<img src="' + mapMarkers[i].image + '" /><br/>' : '';
    content += '<strong>' + mapMarkers[i].name + '</strong><br /><p>' + mapMarkers[i].information + '</p>';
    content += '<div class="marker-buttons"><a class="directions" href="' + mapQuery + '" target="_blank">' + mapMarkers[i].location_icon + '<span>' + '' + '</span></a></div>';

    markers[markerId] = new window.google.maps.Marker({
      position: position,
      map: map,
      title: mapMarkers[i].name,
      icon: 'https://palmia.studio.crasman.fi/pub/web/img/location-marker.png'
    });
    infoWindows[markerId] = new window.google.maps.InfoWindow({
      'content': content
    });

    var marker = markers[markerId];
    var infoWindow = new window.google.maps.InfoWindow();
    window.google.maps.event.addListener(marker, 'click', (function(marker, content, infoWindow) {
      return function() {
        infoWindow.setContent(content);
        infoWindow.open(map, marker);
      };
    })(marker, content, infoWindow));

  }
}

if(typeof parkingAreas !== 'undefined') {

  var script_tag = document.createElement('script');
  script_tag.setAttribute('type','text/javascript');
  script_tag.setAttribute('src','https://maps.googleapis.com/maps/api/js?key=AIzaSyCaEyfXwM5YII5VKjy_SMV6geh8yAWBeuw&callback=initParkingMap');
  (document.getElementsByTagName('head')[0] || document.documentElement).appendChild(script_tag);
  setTimeout(initParkingMap, 500);

}
